module.exports = __webpack_public_path__ + "media/images/beauty/card-mobile@3x-d20aacab49e7e55c10bf208b9feb7344.jpg";